import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { UNSAFE_media } from "@atlaskit/primitives/responsive";

import TabGroup, {
    IndividualTabPropsCustom,
    TabColorProps
} from "../../../../../../../components/wpl/tab-group/src";
import { Row } from "../../../../../../../libraries/wpl/foundations/src";

import {
    SoftwareTeams,
    MarketingTeams,
    Operations,
    ProductTeams,
    DesignTeams
} from "./content";

const tabStyles: TabColorProps = {
    defaultBG: "n0",
    defaultText: "n900",
    hoverBG: "n0",
    hoverText: "n900",
    activeBG: "b50",
    activeText: "n900"
};

const tabCustomStyles = css({
    "marginTop": "40px",
    "marginBottom": "60px",

    ".row-layout": {
        "width": "100%",
        "@media (min-width: 376px)": {
            width: "100%"
        },
        "@media (min-width: 768px)": {
            width: "768px"
        },
        "@media (min-width: 1024px)": {
            width: "1024px"
        },
        "@media (min-width: 1440px)": {
            width: "1168px"
        }
    },

    ".tab-group .tab-panels .tab-panel .row-layout": {
        alignItems: "center"
    },

    '.tab-group .tab-group-inner button[aria-selected="false"]': {
        color: "#6b778c"
    },

    ".tab-group .tab-group-inner": {
        marginBlockEnd: "20px"
    },

    ".tab-group .tab-group-inner button": {
        "border": "1px solid transparent",
        "fontSize": "0.875rem",
        "@media (min-width: 1024px)": {
            fontSize: "1.25rem"
        }
    },

    ".tab-group .tab-group-inner button:hover": {
        border: "1px solid #deebff"
    },

    ".tab-group .tab-panel h2": {
        "color": "#253858",
        "fontSize": "1.5rem",

        "@media (min-width: 758px)": {
            fontSize: "2.25rem"
        }
    }
});

const tabSectionTitleStyles = css({
    "textAlign": "center",
    "fontSize": "1.5rem",
    "marginBlockEnd": "40px",
    "fontWeight": "500",
    "color": "#253858",

    "@media(min-width: 768px)": {
        fontSize: "2.25rem"
    }
});

const TabsPaidLpJswPm = () => {
    const intl = useIntl();

    const tabs: IndividualTabPropsCustom[] = [
        {
            textLabel: intl.formatMessage({
                id: "JiraSoftwarePage.PaidLpJswPm.tabs.softwareTeams",
                defaultMessage: "Software teams"
            }),
            id: "software+teams",
            component: SoftwareTeams()
        },
        {
            textLabel: intl.formatMessage({
                id: "JiraSoftwarePage.PaidLpJswPm.tabs.marketingTeams",
                defaultMessage: "Marketing teams"
            }),
            id: "marketing+teams",
            component: MarketingTeams()
        },
        {
            textLabel: intl.formatMessage({
                id: "JiraSoftwarePage.PaidLpJswPm.tabs.operations",
                defaultMessage: "Operations"
            }),
            id: "operations",
            component: Operations()
        },
        {
            textLabel: intl.formatMessage({
                id: "JiraSoftwarePage.PaidLpJswPm.tabs.productTeams",
                defaultMessage: "Product teams"
            }),
            id: "product+teams",
            component: ProductTeams()
        },
        {
            textLabel: intl.formatMessage({
                id: "JiraSoftwarePage.PaidLpJswPm.tabs.designTeams",
                defaultMessage: "Design teams"
            }),
            id: "design+teams",
            component: DesignTeams()
        }
    ];

    return (
        <div css={tabCustomStyles}>
            <Row layout="12">
                <h2 css={tabSectionTitleStyles}>
                    {intl.formatMessage({
                        id: "JiraSoftwarePage.PaidLpJswPm.tabs.headerText",
                        defaultMessage:
                            "Jira is custom-built for the work your team does"
                    })}
                </h2>
            </Row>
            <TabGroup
                tabContentType="custom"
                tabs={tabs}
                id="tabs"
                label="tabs"
                colors={tabStyles}
            />
        </div>
    );
};

export default TabsPaidLpJswPm;
